export const SQ = {
    translations: {
        notifications: 'Njoftimet',
        markAllAsRead: 'Shënoni të gjitha si të lexuara',
        poweredBy: 'Mundësuar nga',
        settings: 'Cilësimet',
        noNewNotification: 'Nuk ka asgjë të re për të parë këtu ende',
    },
    lang: 'sq',
};
//# sourceMappingURL=sq.js.map